import { ARGENTUS_CONTACT_INFO } from './constants';

export const LANDING_TEXTS = {
  HERO_TITLE: 'ARTESANÍA DIGITAL',
  HERO_SUBTITLE: 'Tú visión, en tres dimensiones',
  CATALOG_BUTTON: 'Ver catálogo',
  QUOTE_BUTTON: 'Cotizar encargo',
  CHECK_PRODUCTS: 'Revisa los productos nuevos y los más vendidos',
  CATEGORIES_TITLE: 'Compra por categoría',
  FEATURES_ITEMS: {
    DESIGNS: {
      TITLE: 'Diseños Únicos',
      DESCRIPTION: 'Elige colores, nombres y detalles específicos. Adaptamos cada modelo para crear piezas únicas que se ajusten exactamente a lo que tienes en mente.',
    },
    MATERIALS: {
      TITLE: 'Material de Alta Calidad',
      DESCRIPTION: 'Utilizamos PLA y todas sus variables: termoplástico biodegradable derivado de recursos renovables como el maíz. Acabado resistente, duradero y amigable con el medio ambiente.',
    },
    CUSTOM: {
      TITLE: 'Post-Procesado a Mano',
      DESCRIPTION: 'La impresión es solo el inicio. Lijamos, preparamos y pintamos cada pieza a mano para asegurar un nivel de detalle y un acabado profesional impecable.',
    },
  },
  CUSTOM_REQUEST: {
    TITLE: '¿TIENES UNA IDEA EN MENTE?',
    SUBTITLE: 'La convertimos en tangible.',
    BUTTON: 'COTIZAR ENCARGO >',
  },
  MANDALAS_SECTION: {
    TITLE: 'Mandalas Vivos con Suculentas',
    PHRASES: ['Creado con amor', 'Decora con vida', 'Armonía que perdura'],
    BUTTON: 'VER TODOS',
  },
  DESIGNER_SECTION: {
    TITLE: 'Argentus Mundo 3D. Donde las ideas cobran forma',
    DESCRIPTION: 'Diseñamos y creamos piezas únicas mediante impresión 3D, transformando conceptos en objetos reales con precisión, dedicación y atención al detalle. Utilizamos PLA, un material biodegradable derivado del maíz 🌽, combinando innovación, creatividad y compromiso con el futuro.',
    TAG_LABEL: 'Emprendimiento local',
  },
};

export const FOOTER_TEXTS = {
  BRAND: {
    TITLE: 'Argentus Mundo 3D',
    DESCRIPTION: 'Servicio de impresión 3D personalizada en Arica, Chile, para proyectos, regalos y empresas.',
  },
  SOCIAL: {
    INSTAGRAM_LABEL: 'Instagram',
    FACEBOOK_LABEL: 'Facebook',
    WHATSAPP_LABEL: 'WhatsApp',
  },
  NAV: {
    TITLE: 'Explorar',
    ITEMS: [
      { label: 'Catálogo de productos', link: '/catalogo' },
      { label: 'Cotizar proyecto 3D', link: '/encargo', action: 'scroll-to-top' },
      { label: 'Preguntas frecuentes', link: '/faq' },
      { label: 'Envíos y entregas', link: '/envios' },
    ],
  },
  SCHEDULE: {
    TITLE: 'Horario',
    LINES: [
      'Lunes a Viernes: 18:00-19:00',
      'Sábado: 16:00-23:00',
      'Domingo: cerrado',
    ],
  },
  CONTACT: {
    EMAIL: ARGENTUS_CONTACT_INFO.EMAIL,
    ADDRESS: ARGENTUS_CONTACT_INFO.ADDRESS,
    PHONE: ARGENTUS_CONTACT_INFO.PHONE_NUMBER,
  },
  LEGAL: {
    TERMS: 'Términos y Condiciones',
    PRIVACY: 'Política de Privacidad',
  },
  COPYRIGHT_SUFFIX: 'Argentus Mundo 3D',
};

export const NAV_BAR_TEXTS = {
  HOME: 'Inicio',
  CATALOG: 'Catálogo',
  CUSTOM_ORDER: 'Encargo',
  CONTACT: 'Contacto',
};

export const LANDING_MANAGEMENT_TEXTS = {
  COMING_SOON_BADGE: 'Próximamente',
  COMING_SOON_WARNING: 'Este producto está en Próximamente: se mostrará en la página principal, pero no se puede comprar.',
};
